<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div class="card-header">
            <i class="fa fa-align-justify"></i> Survey Answers
          </div>
          <div v-if="!answersReady" class="table-loading-container">
            <img
              src="/img/wifi-loading.gif"
              alt="loading"
              class="loading-table"
            />
          </div>
          <div v-if="answersReady">
            <div v-if="!answers.length">
              <b-alert show variant="warning">
                No Surveys Answered
              </b-alert>
            </div>
            <table class="table table-striped" v-if="answers.length">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Survey</th>
                  <th>Question</th>
                  <th>Answers</th>
                  <th class="action-single"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="answer in answers" :key="answer._id">
                  <td>{{ answer.dateAdded | formatDate }}</td>
                  <td>{{ answer.survey.name }}</td>
                  <td>{{ answer.question.name }}</td>
                  <td>{{ displayAnswers(answer.options) }}</td>
                  <td>
                    <button
                      class="btn btn-sm btn-danger"
                      @click="deleteAnswer(answer._id)"
                    >
                      <i class="fa fa-remove"></i> Delete
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "answers",
  data() {
    return {
      answersReady: false
    };
  },
  computed: {
    userId() {
      return this.$route.params.userId;
    },
    answers() {
      return this.$store.getters.userAnswers;
    }
  },
  methods: {
    displayAnswers(options) {
      return options
        .map(option => {
          return option.name;
        })
        .join(", ");
    },
    deleteAnswer(id) {
      let scope = this;
      scope.$store.dispatch("deleteAnswer", id).then(
        result => {
          scope.getAnswers();
        },
        error => {
          console.log(error);
        }
      );
    },
    getAnswers() {
      let scope = this;
      scope.$store.dispatch("getUserAnswers", scope.userId).then(
        result => {
          this.answersReady = true;
        },
        error => {
          this.answersReady = true;
          console.log(error);
        }
      );
    }
  },
  created() {
    this.getAnswers();
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
